interface Css {
    name: string;
    src: string;
}
export const CssStore: Css[] = [
    { name: "kendoCommon", src: "https://kendo.cdn.telerik.com/2019.2.619/styles/kendo.common.min.css" },
    { name: "kendoDefault", src: "https://kendo.cdn.telerik.com/2019.2.619/styles/kendo.default.min.css" }
];